import apiSales from '../apiSales';

import { ParamsBodyPostCreateLead, ParamsDataPostCreateLead } from 'utils/typeServices';

type response = {
    success: boolean;
    message: Array<string>;
    Data: ParamsDataPostCreateLead;
}

export const PostCreateLead = async (body: ParamsBodyPostCreateLead) => {
    const bodyJson = body;
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiSales.post<response>('/lead', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data.Data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
